import { useAssignedClientSelection } from "../../../hooks";
import { ToolsRunAdmin } from "./ToolsRunAdmin";

export const ToolsRunClient = () => {
  const { clientOptions, selectedClientId, setSelectedClientId } =
    useAssignedClientSelection();

  return (
    <ToolsRunAdmin
      clientMode
      assignedClientOptions={clientOptions}
      assignedClientId={selectedClientId}
      onAssignedClientChange={setSelectedClientId}
    />
  );
};
